// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateShowMoreGroupsVisibility = isMoreSummaryVisible => ({
    isMoreSummaryVisible,
    type: actions.UPDATE_SHOW_MORE_GROUPS_VISIBILITY
});



// WEBPACK FOOTER //
// ./src/pip/labor-additive/action-creators/show-more-groups-visibility.js